import * as React from 'react';
import { connect } from 'react-redux';
import Dropdown, { DropDownPosition } from 'components/DropDownMenu/DropDownMenu';
import get from 'lodash/get';
import cx from 'classnames';
import { stringTemplate } from 'components/StringWidget/StringWidget';
import { Chevron, SignOutIcon } from 'components/Icons/Icons';
import { LOCKIN_UNKNOWN } from 'constants/LoginConstants';
import { Link } from 'react-router';
import omnitureHelper from 'utils/omnitureHelper';
import { logoutAction } from 'actions/LoginSignupActions/logoutActions';
import { markAllNotificationAsReadAction } from 'actions/inAppNotificationsActions';
import defaultStyles from './Menu.css';
import { ACCOUNT_LINKS, VIP_LOCKIN_ID, DROP_MENU_MAX_WIDTH } from './MenuComponentConstants';
class AccountDropDown extends React.Component {
    constructor(props) {
        super(props);
        this.handleLogout = (e) => {
            e && e.preventDefault();
            this.props.logout();
        };
        this.handleAccountToggle = (show) => () => {
            if (show) {
                const unreadCount = get(this.props.userState, ['notifications', 'unreadCount'], 0);
                unreadCount > 0 && this.props.markAllNotificationAsRead();
            }
            this.setState({
                showAcountDropDown: show
            });
        };
        this.handleDropDownTrackClick = (props) => () => {
            if (props.lockinId !== VIP_LOCKIN_ID) {
                return;
            }
            const omniFields = {
                prop47: 'loki_vip_flyout_click',
                prop3: 'My Account',
                prop4: 'My Account: login',
                pageName: 'My Account: login'
            };
            omnitureHelper.trackLink(omniFields, 'Flyout Vip Clicked');
        };
        this.renderLink = (item, i, styles) => {
            return (<li key={`acclinks-${i}`} className={styles['links-item']} onClick={this.handleDropDownTrackClick(item)}>
				{item.openExternal ? (<a href={item.href} className={styles['link']}>
						{item.icon && <item.icon width={item.width} height={item.height}/>}
						<div className={styles['item-link']} data-aid={item['dataAid']}>
							{item.text}
						</div>
						{item.countType && this.getCount(item.countType, styles)}
					</a>) : (<Link to={item.href} className={styles['link']}>
						{item.icon && <item.icon width={item.width} height={item.height}/>}
						<div className={styles['item-link']} data-aid={item['dataAid']}>
							{item.text}
						</div>
						{item.countType && this.getCount(item.countType, styles)}
					</Link>)}
			</li>);
        };
        this.getAccountDropDownData = (styles, minimal) => {
            const lockInState = get(this.props, ['userState', 'lockinResponse', 'userMembershipState']);
            const accountLinks = ACCOUNT_LINKS.filter(link => {
                if (lockInState === LOCKIN_UNKNOWN && link['lockinId'] === VIP_LOCKIN_ID) {
                    return null;
                }
                return link;
            });
            const isMinimal = !(minimal && minimal.length > 0);
            return (<ul className={cx(styles['links'], { [styles['minimal']]: isMinimal })}>
				{accountLinks.map((item, i) => {
                return this.renderLink(item, i, styles);
            })}
				<li className={styles['links-item']}>
					<a href="#" className={styles['link']} onClick={this.handleLogout}>
						<SignOutIcon width={16} height={16}/>
						<div className={styles['item-link']}>{stringTemplate('logout')}</div>
					</a>
				</li>
			</ul>);
        };
        this.state = {
            showAcountDropDown: false
        };
    }
    getCount(countType, styles) {
        let view = null;
        const userState = this.props.userState;
        switch (countType) {
            case 'notification':
                const notificationCount = get(userState, ['notifications', 'unreadCount'], 0);
                view =
                    notificationCount > 0 ? (<div className={cx(styles['count'], styles['notification-count'])}>{notificationCount}</div>) : null;
                break;
            case 'wishlist':
                const wishListlCount = get(userState, ['wishlist', 'totalElements'], 0);
                view =
                    wishListlCount > 0 ? (<div className={cx(styles['count'], styles['wishlist-count'])}>{wishListlCount}</div>) : null;
                break;
            default:
                view = null;
                break;
        }
        return view;
    }
    render() {
        const { minimal, userState, coBrandStyles } = this.props;
        const styles = Object.assign({}, defaultStyles, coBrandStyles);
        const position = minimal === 'CART' ? DropDownPosition.LEFT : DropDownPosition.CENTER;
        const notificationCount = get(userState, ['notifications', 'unreadCount']);
        const accountText = (<div className={styles['account-name']}>{userState.firstName || stringTemplate('myOrdersAccount')}</div>);
        return (<div className={styles['item-container']} onMouseEnter={this.handleAccountToggle(true)} onClick={this.handleAccountToggle(!this.state.showAcountDropDown)} onMouseLeave={this.handleAccountToggle(false)}>
				<Dropdown position={position} fixPosition contentMaxWidth={DROP_MENU_MAX_WIDTH} content={accountText} active={this.state.showAcountDropDown} className={styles['drop-menu']} tooltipClassName={styles['dropdown-container']} containerClassName={styles['dropdown-inner-container']}>
					{this.getAccountDropDownData(styles, minimal)}
				</Dropdown>
				{!this.state.showAcountDropDown && notificationCount ? (<div className={styles['notify-count']}/>) : (<Chevron width={4.7} height={8} className={cx(styles['chevron'], { [styles['active']]: this.state.showAcountDropDown })} pathClassName={styles['chevron-path']}/>)}
			</div>);
    }
}
const mapDispatchToProps = {
    logout: logoutAction,
    markAllNotificationAsRead: markAllNotificationAsReadAction
};
export default connect(null, mapDispatchToProps)(AccountDropDown);
